export const ORG_EDITING_VIEW = "ORG_DETAILS";
export const ORG_TABLE_VIEW = "ORG_TABLE_LIST";
export const TENANT_EDITING_VIEW = "TENANT_DETAILS";
